// extracted by mini-css-extract-plugin
export var statItem = "_d1-1";
export var statsRow = "_d1-0";